export default {
    p3611aa00: "M10 12.5L5.83333 8.33333H14.1667L10 12.5Z",
  };
  